require('./bootstrap'); //
require('./custom/frontend'); //
require('./custom/swiper'); // npm install swiper --save
// require('./custom/isotope'); // npm install isotope-layout --save
// require('./custom/countup'); // npm install countup.js --save
require('./custom/animate'); // npm install animejs --save

// npm install external-svg-loader --save
// npm install @popperjs/core --save

// npm install @fortawesome/fontawesome-pro --save
// Don´t forget .npmrc - from other project or generate new
// npm config set "@fortawesome:registry" https://npm.fontawesome.com/
// npm config set "//npm.fontawesome.com/:_authToken" FONT-AWESOME-PACKAGE-FONT-AWESOME-PACKAGE-TOKEN

import 'bootstrap'; // npm install bootstrap@5.2.1 --save
import 'vanilla-cookieconsent/dist/cookieconsent.js'; // npm install vanilla-cookieconsent --save
import Vue from 'vue'; // npm install vue@2.7.3 --save

Vue.component('CookieConsent', require('./components/CookieConsent.vue').default);

const app = new Vue({
    el: '#app',
});
